"use client";
'use strict';

var React = require('react');
var UserProvider = require('../providers/UserProvider.js');

function useUser() {
    const user = React.useContext(UserProvider.UserContext);
    return user;
}

exports.useUser = useUser;
//# sourceMappingURL=useUser.js.map
